/**
 * Handles all header related stuff.
 */
export default class Header {
  constructor() {
    if (this.dependencies()) {
      this.addEventListeners();
    }
  }

  /**
   * Get all needed html elements
   */
  dependencies = () => {
    this.headerInnerWrapper = document.querySelector(".header__inner-wrapper");
    if (this.headerInnerWrapper == null) return false;

    this.mobileButton = document.querySelector(".header__mobile-button");
    if (this.mobileButton == null) return false;

    this.mobileOverlay = document.querySelector(".mobile-overlay");
    if (this.mobileOverlay == null) return false;

    this.mobileOverlayLinks = this.mobileOverlay.querySelectorAll("a");
    if (this.mobileOverlayLinks == null) return false;

    return true;
  };

  /**
   * Register event handler
   */
  addEventListeners = () => {
    window.addEventListener("scroll", this.handleScroll);
    this.mobileButton.addEventListener("click", this.handleMobileButtonClick);
    this.mobileOverlayLinks.forEach((link) =>
      link.addEventListener("click", this.handleMobileOverlayLinkClick)
    );
  };

  /**
   * Event handler for window scroll event.
   * Shows the box shadow for the menu
   * at a specific Y value, or hides it.
   */
  handleScroll = () => {
    if (window.scrollY > 100) {
      this.headerInnerWrapper.classList.add("shadow-theme");
    } else {
      this.headerInnerWrapper.classList.remove("shadow-theme");
    }
  };

  handleMobileButtonClick = () => {
    if (this.mobileButton.classList.contains("menu-open")) {
      this.mobileButton.classList.remove("menu-open");
      this.mobileOverlay.classList.remove("mobile-overlay--open");
      setTimeout(() => {
        this.mobileOverlay.classList.add("hidden");
      }, 300);
    } else {
      this.mobileButton.classList.add("menu-open");
      this.mobileOverlay.classList.remove("hidden");
      setTimeout(() => {
        this.mobileOverlay.classList.add("mobile-overlay--open");
      }, 0);
    }
  };

  handleMobileOverlayLinkClick = () => {
    this.handleMobileButtonClick();
  };
}
